<template>
  <div class="project-container" v-if="project">
    <div class="project-content-container">
      <a @click="onBackButton">Back to Projects</a>
      <div class="project-card">
        <div class="project-header">
          <div>
            <h1 class="project-title">{{ project.title }}</h1>
            <div class="project-location">{{ project.location }}</div>
          </div>
          <a
            class="normal-button"
            :class="applied ? 'applied-button' : 'apply-button'"
            @click="onApplyButton"
            >{{ applied ? "Applied" : "Apply" }}</a
          >
        </div>
        <article>
          <div v-if="project.task">
            <h5>Task:</h5>
            <p class="preline" v-html="project.task" />
          </div>
          <div v-if="role.requirements">
            <h5>Requirements:</h5>
            <p class="preline" v-html="role.requirements" />
          </div>
          <div v-if="project.client_description">
            <h5>Client:</h5>
            <p class="preline" v-html="project.client_description" />
          </div>
          <h5>Info:</h5>
          <ul>
            <li>Engagement Length: {{ project.engagement }}</li>
            <li>Estimated start: {{ project.start }}</li>
            <li>Hours per week: {{ role.hours_per_week }}</li>
          </ul>
        </article>
        <hr />
        <h6>Hiring Policy</h6>
        <small
          >ScaleDesk is a marketplace that matches IT technicians with corporate
          clients on either flexbile, part-time or full-time contracts.
          Contracts will be paid at the rate mentioned in the role. All roles
          will be on a 1099 basis.</small
        >
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import moment from "moment-timezone";

export default {
  props: ["projectId", "roleId", "consultantId"],
  data() {
    return {
      project: null,
      role: null,
      applied: false,
    };
  },
  watch: {
    project: function () {
      this.update();
    },
    consultantId: function () {
      this.update();
    },
    projectId: function () {
      this.bindData();
    },
  },
  mounted() {
    this.bindData();
  },
  methods: {
    bindData: function () {
      if (this.projectId && this.roleId) {
        this.$bind("project", db.collection("gigs").doc(this.projectId));
      }
    },
    update: function () {
      this.project.start = moment(this.project.estimated_start * 1000).format(
        "MM/DD/YYYY"
      );
      if (this.project.roles && this.project.roles.length > 0) {
        this.role = this.project.roles.find((item) => item.id === this.roleId);
      }
      if (
        this.consultantId &&
        this.project.selected_consultants &&
        this.project.selected_consultants.length > 0
      ) {
        const consultants = this.project.selected_consultants.find(
          (item) => item.role_id === this.roleId
        );
        if (consultants) {
          const consultant = consultants.consultants.find(
            (item) => item.id === this.consultantId
          );
          if (consultant) {
            this.applied = consultant.reply === "yes";
          }
        }
      }
    },
    onApplyButton: function () {
      if (this.applied) return;
      this.$emit("onApplyButton");
    },
    onBackButton: function () {
      this.$emit("onBackButton");
    },
  },
};
</script>

<style scoped>
a {
  font-family: "avenir-next-block";
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
}
h5 {
  font-family: "avenir-next-block";
  font-size: 1.25em;
  margin: 1.5em 0 1em;
  color: #2c3038;
}
h6 {
  font-family: "avenir-next-block";
  font-size: 1em;
  margin: 0 0 1em;
  color: #2c3038;
}
small {
  font-family: "avenir-next-block";
  font-size: 0.75em;
}
ul {
  padding-left: 2em !important;
}
li {
  list-style: disc !important;
}
hr {
  border-top: 1px solid #eaedf2;
  border-bottom: none;
  margin: 1.5em 0;
}
.background {
  font-size: 16px !important;
  line-height: 1.5 !important;
  color: #555a64 !important;
  background: #f7f9fc;
  min-height: 100vh;
}
.background * {
  box-sizing: border-box;
}
.project-container {
  padding: 96px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.project-content-container {
  padding: 0 12px;
  margin: 0 auto;
}
.project-card {
  max-width: 800px;
  margin-top: 1.5em;
  box-shadow: 0 0.5em 1em rgb(0 0 0 / 9%);
  padding: 2.25em;
  word-wrap: break-word;
  background-color: #fff;
  border: 1px solid #eaedf2;
  border-radius: 0.3125em;
}
.project-header {
  margin-bottom: 3em;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #eaedf2;
  flex-wrap: wrap;
}
.project-title {
  max-width: 550px;
  font-family: "avenir-next-block";
  font-size: 2.5em;
  font-weight: 700;
  color: #2c3038;
  margin: 0 0 0.5em;
}
.project-location {
  font-family: "avenir-next-block";
  font-size: 1em;
  color: #555a64;
  margin-bottom: 1.5em;
}
.preline {
  white-space: pre-line;
}
.normal-button {
  color: #fff;
  text-align: center;
  vertical-align: middle;
  padding: 0.625em 1.5em;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 100px;
  margin-bottom: 1.5em;
}
.apply-button {
  background-color: #1a73e8;
}
.applied-button {
  background-color: gray;
}
@media screen and (max-width: 375px) {
  .project-title {
    font-size: 2em;
  }
}
@media screen and (max-width: 500px) {
  .project-title {
    font-size: 1.5em;
    font-weight: 600;
    word-wrap: break-word;
  }
}
</style>
